"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderDto = void 0;
const baseFolderDto_1 = require("./baseFolderDto");
class FolderDto extends baseFolderDto_1.BaseFolderDto {
    constructor(folderDto) {
        super({
            name: folderDto.name,
            parentId: parseInt(folderDto.parent_id),
            id: parseInt(folderDto.id),
            externalId: folderDto.external_id,
            isPersonal: folderDto.is_personal,
        });
        this.childCount = folderDto.child_count;
        this.creatorId = folderDto.creator_id;
        this.can = folderDto.can;
        this.dashboards = folderDto.dashboards;
        this.looks = folderDto.looks;
        this.isPersonal = folderDto.is_personal;
        this.isSharedRoot = folderDto.is_shared_root;
        this.isEmbed = folderDto.is_embed;
        this.createdBy = folderDto.createdBy;
    }
    static get QUERY_FIELDS() {
        return `${baseFolderDto_1.BaseFolderDto.QUERY_FIELDS},creator_id,child_count,can,dashboards,looks,is_shared_root,is_embed`;
    }
    static get ROOT_REQUEST_FIELDS() {
        return `${baseFolderDto_1.BaseFolderDto.QUERY_FIELDS},is_embed,dashboards,looks`;
    }
    static get SUMMARY_REQUEST_FIELDS() {
        return `${baseFolderDto_1.BaseFolderDto.QUERY_FIELDS},is_embed,child_count,can`;
    }
}
exports.FolderDto = FolderDto;
